module.exports = __webpack_public_path__ + "images/mobile/init/member-group-a041018891e2533b9d391772378a4049.png";